<template>
  <div class="header-top flex-row">
    <div class="nav-box flex-row">
      <img
        class="logo-image"
        referrerpolicy="no-referrer"
        src="../../assets/fd_logo.png"
      />
      <a
        class="nav-item"
        target="_self"
        href="javascript:void(0)"
        @click="toHome()"
      >
        首页
      </a>
      <div
        class="nav-item"
        v-for="(item, i) in navList"
        @click="toNav(item)"
        :key="i"
        :class="'nav_item' + i"
      >
        {{ item.name }}
        <span v-if="item.children">
          <svg-icon
            style="left: 10px; top: 10px; font-size: 18px"
            icon-class="triangleDown"
          />
        </span>
        <div class="nav-child-box" v-if="item.children">
          <div
            class="nav-child-item"
            v-for="child in item.children"
            :key="child.id"
            @click.stop="toNav(child)"
          >
            {{ child.name }}
          </div>
        </div>
      </div>
      <div class="header-toolbar flex-col justify-between">
        <div class="jump-link flex-row justify-between">
          <a target="_blank" :href="jumpLiknData[0].href">{{
            jumpLiknData[0].name
          }}</a
          >|
          <a target="_blank" :href="jumpLiknData[1].href">{{
            jumpLiknData[1].name
          }}</a>
        </div>
        <div class="toolbar-bnt flex-row justify-between">
          <div class="zx-box flex-row">
            <img
              class="thumbnail_4"
              referrerpolicy="no-referrer"
              src="../../assets/zx-button.png"
            />
            <div class="show-zx-box">
              <div class="zx-content">
                <div class="zxzx-box zx-item flex-row">
                  <div class="zx-icon">
                    <img src="../../assets/zx-zxzx-icon.png" />
                  </div>
                  <div>
                    <div class="img-bnt flex-row">
                      <a
                        target="_blank"
                        href="https://irobot.fudan.edu.cn/webchatbot/chat.html?sysNum=1617934087685&sourceId=70253&lang=zh_CN"
                        >管小图机器人</a
                      >
                      <a class="zxgy-box"
                        >咨询馆员
                        <div class="zxgy-content">
                          <div>
                            <img src="../../assets/zxgy-img.png" />
                          </div>
                          <div style="margin-top: 4px">8：00-17：00</div>
                          <div>（周一至周五）</div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="dhzx-box zx-item flex-row">
                  <div class="zx-icon">
                    <img src="../../assets/zx-dhzx-icon.png" />
                  </div>
                  <div class="dhzx-content">
                    <div>
                      <div>(021)25011000-4025</div>
                      <div>服务时间：8：00-22：00（周一至周日）</div>
                    </div>
                  </div>
                </div>
                <div class="yxzx-box zx-item flex-row">
                  <div class="zx-icon">
                    <img src="../../assets/zx-yxzx-icon.png" />
                  </div>
                  <div>
                    <div>
                      <div>lms@fudan.edu.cn</div>
                      <div>我们将于3个工作日内给予回复</div>
                    </div>
                  </div>
                </div>
                <div class="dmzx-box zx-item flex-row">
                  <div class="zx-icon">
                    <img src="../../assets/zx-dmzx-icon.png" />
                  </div>
                  <div>
                    <div>
                      <div>上海市国顺路670号李达三楼4楼</div>
                      <div>服务时间：8：00-22：00（周一至周日）</div>
                      <div v-if="config.enable == '1' && pNumber > 0">
                        <div class="appointment_box" @click="toAppointment">
                          预约咨询
                        </div>
                        <div>
                          本期剩余可预约名额：<span style="color: #409eff">{{
                            pNumber
                          }}</span>
                          人
                        </div>
                      </div>
                      <template v-else-if="config.enable == '0'">
                        <el-popover
                          placement="top-start"
                          width="200"
                          trigger="hover"
                          :content="config.info1"
                        >
                          <div
                            slot="reference"
                            class="appointment_box pause_status"
                          >
                            本期预约服务暂停
                          </div>
                        </el-popover>
                      </template>
                      <div v-else-if="pNumber < 1">
                        <div class="appointment_box pause_status">
                          本期预约名额已满
                        </div>
                        <div>
                          本期剩余可预约名额：<span>{{ pNumber }}</span
                          >人
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="wxzx-box zx-item flex-row">
                  <div class="zx-icon">
                    <img src="../../assets/zx-wxzx-icon.png" />
                  </div>
                  <div>
                    <img src="../../assets/zx-wxzx-img.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { post, get } from "@u/request";

export default {
  name: "",
  components: {},
  props: {
    copyright: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      drawer: false,
      jumpLiknData: [
        {
          name: "管理学院",
          href: "https://www.fdsm.fudan.edu.cn/AboutUs/default.html",
        },
        {
          name: "复旦大学图书馆",
          href: "http://www.library.fudan.edu.cn/",
        },
      ],
      navList: [],
      config: {},
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.isPosition = to.path === "/home";
      },
      immediate: true,
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    pNumber() {
      return this.$store.getters.pNumber;
    },
  },
  methods: {
    toHome() {
      this.$router.push("/home");
    },
    async getNavList() {
      const { data } = await get("lib/menu/list");
      this.navList = this.handleTree(data, "id", "pid", "", "status");
      sessionStorage.setItem("menuList", JSON.stringify(data));
    },
    toNav(item) {
      if (item.url.toLowerCase().indexOf("http") > -1) {
        window.open(item.url);
      } else if (item.url.indexOf("comPage") > -1) {
        this.$router.push(item.url + "/" + item.id);
      } else if (item.url) {
        this.$router.push(item.url);
      }
    },
    toAppointment() {
      this.$router.push("/appointment");
    },
    async getConfig() {
      const { data } = await get("lib/consult/getConfig");
      const config = data[0];
      if (config) {
        this.config = config;
      }
    },
    getCheck() {
      this.$store.dispatch("getCheck");
    },
  },
  mounted() {},
  created() {
    this.getNavList();
    this.getConfig();
    this.getCheck();
  },
};
</script>

<style scoped lang="scss">
.header-top {
  position: absolute;
  min-width: 1400px;
  width: 100%;
  height: 128px;
  background: url(../../assets/nav.png) 100% no-repeat;
  background-size: 100% 100%;
  top: 0;
  margin: 0;
  left: 0;
  z-index: 10;
}

.logo-image {
  width: 212px;
  height: 64px;
  // margin: 31px 0 0 100px;
  margin-right: 20px;
}

.nav-box {
  // width: 100%;
  min-width: 1400px;
  margin: 0 auto;
  align-items: center;
  .nav-item {
    position: relative;
    color: rgba(255, 255, 255, 1);
    font-size: 22px;
    font-weight: 700;
    cursor: pointer;
    padding: 0 20px;
    .nav-child-box {
      position: absolute;
      background: #004896bf;
      display: none;
      left: -20%;
      padding: 10px;
      font-size: 16px;
      border-radius: 5px;
      text-align: center;
      line-height: 40px;
    }

    .nav-child-item {
     // padding: 0 20px;
    }
  }
  .nav_item0 {
    .nav-child-box {
      min-width: 150px;
      white-space: nowrap;
    }
  }
  .nav_item1 {
    .nav-child-box {
      min-width: 150px;
      white-space: nowrap;
    }
  }
  .nav_item2 {
    .nav-child-box {
      min-width: 150px;
      white-space: nowrap;
    }
  }
  .nav-item:hover .nav-child-box {
    display: block;
  }
}
.header-toolbar {
  height: 61px;
  margin-left: auto;

  .jump-link {
    width: 200px;
    height: 20px;
    color: #fff;
    a {
      color: #fff;
    }
  }

  .toolbar-bnt {
    width: 200px;
    height: 29px;
  }

  .ss-box {
    cursor: pointer;
    position: relative;
  }

  .zx-box {
    // background: #092441;
    position: relative;
    margin-left: 60px;
    width: 102px;
    height: 30px;
    font-size: 14px;
    line-height: 24px;
    .thumbnail_4 {
      cursor: pointer;
    }
    .show-zx-box {
      position: absolute;
      background: url(../../assets/zx-bg.png) 100% no-repeat, #425c79;
      background-size: 100% 100%;
      width: 500px;
      top: 30px;
      right: -36px;
      border-radius: 14px;
      border-top-right-radius: 0px;
      display: none;
    }
    .zx-content {
      margin: 20px;
    }

    .zx-item {
      margin-bottom: 20px;
    }

    .zx-icon {
      width: 170px;
    }
    .appointment_box {
      margin-top: 8px;
      padding: 4px 20px;
      background: #004896;
      color: #fff;
      cursor: pointer;
      border-radius: 5px;
      display: inline-block;
    }
    .pause_status {
      color: #fff;
      background-color: #c8c9cc;
      cursor: no-drop;
    }
    .img-bnt a {
      margin-top: 8px;
      padding: 4px 20px;
      background: #004896;
      cursor: pointer;
      margin-right: 20px;
      border-radius: 5px;
      color: #fff;
    }

    .zxgy-box {
      position: relative;
    }

    .zxgy-content {
      position: absolute;
      top: 35px;
      background: #004896;
      right: -30px;
      padding: 10px;
      border-radius: 5px;
      text-align: center;
      display: none;
      cursor: default;
      font-size: 12px;
      line-height: 14px;
    }

    .zxgy-box:hover .zxgy-content {
      display: block;
    }

    .zxgy-content img {
      width: 120px;
      height: 120px;
    }

    .yxzx-box {
      // background-image: linear-gradient(to left, #004896 32%,#007EC7 0%);
      // background: linear-gradient(to right, #fff 0%, #EAEDEE 50%, #EAEDEE 80%, #AFC4D8 100%);
    }
  }

  .zx-box:hover .show-zx-box {
    display: block;
  }
}
</style>
